export const lowConfidenceThreshold = 60;
